import React, { Component } from "react";
import { Container, Table, Button, Spinner, Navbar } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { AdminNav, Loading } from "../../helpers";
import axios from "axios";
import {
  convertRiceTypeENToTH,
  addCommaInNumber,
  convertRiceTypeENToENFull,

} from "../../helpers/function";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../datepicker.css";
import { isArray } from "lodash";
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

class CertificateTable extends Component {
  constructor(props) {
    super(props);
    let date = new Date();
    let day = parseInt(date.getDate());
    let month = months[date.getMonth()];
    let year = date.getFullYear();
    let haveDate = this.props?.location?.state?.currentDate;
    let showDate = new Date();
    if (haveDate) {
      let dateArr = haveDate.split(" ");
      let newArr = [];
      dateArr.map((e) => {
        if (e) {
          newArr.push(e);
        }
      });
      dateArr = newArr;
      showDate = new Date(`${dateArr[0]}-${dateArr[1]}-${dateArr[2]}`);
    }
    // console.log(this.props.location?.state)

    this.state = {
      listInComplete: false,
      inCompleteLoading: true,
      completedLoading: false,
      CompanyList: [],
      certNoArr: [],
      riceTypeIDAndName: {},
      certArr: [],
      allCompany: null,
      newCertNoArr: {},
      timeValue:
        this.props?.location?.state?.currentDate ||
        `${day}   ${month}  ${year}`,
      timeShow: showDate,
      minusHeight: this.props.location?.state?.minusHeight || 0,
      yPosition: this.props.location?.state?.yPosition || 0,
      minusCurrentDate: this.props.location?.state?.minusCurrentDate || 0,
      arrCancelData: {},
      minusCertNo: this.props.location?.state?.minusCertNo || 0,
      viewFullNameRiceAsSample: [],
    };
    this.handleTableClick = this.handleTableClick.bind(this);
    this.searchJob = this.searchJob.bind(this);
    this.handleInputCertNo = this.handleInputCertNo.bind(this);
    this.handleClickCreateCertNO = this.handleClickCreateCertNO.bind(this);
    this.onChageDate = this.onChageDate.bind(this);
    this.changeMinusHeight = this.changeMinusHeight.bind(this);
    this.minusCurrentDate = this.minusCurrentDate.bind(this);
    this.renderDisplay = this.renderDisplay.bind(this);
    this.minusCertNo = this.minusCertNo.bind(this);
    this.handlePressEnterCertNo = this.handlePressEnterCertNo.bind(this);
    this.goSearchCertNo = this.goSearchCertNo.bind(this);
    this.handlePressEnterGoSearchCertNo =
      this.handlePressEnterGoSearchCertNo.bind(this);
  }
  componentDidMount() {
    Promise.all([])
      .then((res) => {
        let date = new Date();
        let days = date.getDate();
        if (parseInt(days) < 10) {
          days = `0${days}`;
        }
        let month = parseInt(date.getMonth()) + 1;
        if (parseInt(month) < 10) {
          month = `0${month}`;
        }
        let year = date.getFullYear();
        let saveDate = `${year}-${month}-${days}`;

        // let viewAllCheckWeightComplete = axios.post(
        //   'https://backend1.riceinspections.com/testDE',
        //   {
        //     data: arrFetch
        //   }
        // )
        let viewAllCheckWeightComplete = axios.post(
          "https://backend1.riceinspections.com/testDA",
          {
            data: {
              timeValue: this.props.location?.state?.timeValue || saveDate,
            },
          }
        );

        let viewAllCertificateComplete = axios.post(
          "https://backend1.riceinspections.com/testGE",
          {
            data: {
              timeValue: this.props.location?.state?.timeValue || saveDate,
            },
          }
        );
        let RequestComplete = fetch(
          `https://backend1.riceinspections.com/testA?timeValue=${this.props.location?.state?.timeValue || saveDate
          }`
        ).then((res) => {
          return res.json();
        });
        let viewAllCompany = fetch(`https://backend1.riceinspections.com/testAB`).then(
          (res) => {
            return res.json();
          }
        );

        let viewDateCertificate = axios.post(
          "https://backend1.riceinspections.com/testGC",
          {
            data: {
              timeValue: this.props.location?.state?.timeValue || saveDate,
            },
          }
        );

        let viewFullNameRiceAsSample = fetch(`https://backend1.riceinspections.com/testFC`).then((res) => {
          return res.json()
        })

        Promise.all([
          viewAllCheckWeightComplete,
          RequestComplete,
          viewAllCertificateComplete,
          viewAllCompany,
          viewDateCertificate,
          viewFullNameRiceAsSample,
        ]).then(async (res) => {
          viewAllCheckWeightComplete = res[0]["data"] || {};
          RequestComplete = res[1] || {};
          viewAllCertificateComplete = res[2]["data"] || {};
          viewAllCompany = res[3];
          viewDateCertificate = res[4]?.data;
          let requestIDArr = [];
          Object.values(RequestComplete).map((data) => {
            requestIDArr.push(data["requestID"]);
          });

          axios
            .post("https://backend1.riceinspections.com/testHB", {
              data: { arr: [...new Set(requestIDArr)] },
            })
            .then((jobIDRes) => {
              let jobIDDataArr = jobIDRes["data"];
              let jobIDArr = [];
              const tranformDate = (date) => {
                let dateArr = date.split("-");

                if (dateArr.length == 3) {
                  const months = [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                  ];
                  let shippingDateStr = `${parseInt(dateArr[2])}   ${months[parseInt(dateArr[1]) - 1]
                    }  ${dateArr[0]}`;

                  return shippingDateStr;
                } else {
                  return null;
                }
              };
              Object.values(viewAllCheckWeightComplete).map((data) => {
                jobIDArr.push(data);
              });
              Object.values(RequestComplete).map((requestData) => {
                let requestDescription = requestData["description"]
                if(!Array.isArray(requestDescription)) requestDescription = Object.values(requestDescription)
                requestDescription.map((requestDataDescription) => {
                  if (
                    `${requestDataDescription["licenseID"]}` == "9999999999999"
                  ) {
                    let jobID = 0;
                    Object.values(viewAllCheckWeightComplete).map((data) => {
                      if (data["requestID"] == requestData["requestID"]) {
                        jobID = data["jobID"];
                      }
                    });
                    jobIDArr.push({
                      ...requestDataDescription,
                      ...requestData,
                      jobID: jobID,
                      licenseID: requestDataDescription["licenseID"],
                    });
                  }
                });
              });
              jobIDArr.map((dataJobID, idx) => {
                // console.log(licenseID)
                if (dataJobID['licenseID'] == '0308116631487') {
                  console.log(dataJobID)
                }
              })

              jobIDArr.map((dataJobID, idx) => {
                let IsFoundData = Object.values(RequestComplete).filter((o) => {
                  if (o && dataJobID) {
                    return o["requestID"] == dataJobID["requestID"];
                  }
                });
                let isFoundJobID = Object.values(jobIDDataArr).filter((o) => {
                  if (o && dataJobID) {
                    return o["requestID"] == dataJobID["requestID"];
                  }
                });

                if (IsFoundData.length != 0) {
                  jobIDArr[idx] = {
                    ...jobIDArr[idx],
                    ...IsFoundData[0],
                    License: jobIDArr[idx]["licenseID"],
                    licenseID: jobIDArr[idx]["licenseID"],
                    shippingDate:
                      tranformDate(IsFoundData[0]["shippingDate"]) ||
                      IsFoundData[0]["shippingDate"],
                    jobID: isFoundJobID[0]?.["jobID"] || 0,
                    // isComplete : true,
                  };

                  let isFoundDataDescription = IsFoundData[0][
                    "description"
                  ].filter((o) => {
                    return (
                      o["licenseID"] == dataJobID["licenseID"] &&
                      o["subID"] == dataJobID["subID"]
                    );
                  });
                  if (isFoundDataDescription.length != 0) {
                    if (dataJobID["licenseID"] != "9999999999999") {
                      jobIDArr[idx] = {
                        ...jobIDArr[idx],
                        checkWeight: isFoundDataDescription[0],
                        isCheckWeightComplete: true,
                      };
                      // console.log(jobIDArr[idx])
                    } else {
                      jobIDArr[idx] = {
                        ...jobIDArr[idx],
                      };
                    }
                    // console.log(isFoundDataDescription[0])
                  }
                }
                if(viewAllCertificateComplete?.err){ viewAllCertificateComplete = []}
                viewAllCertificateComplete.map((data) => {
                  if (data) {
                    let isFoundCertificate = Object.values(data).filter((o) => {
                      // console.log(o)
                      return (
                        o["License"] == dataJobID["licenseID"] &&
                        o["subID"] == dataJobID["subID"] &&
                        o["No"] &&
                        o["jobID"] == dataJobID["jobID"]
                      );
                    });
                    if (isFoundCertificate.length != 0) {
                      if (isFoundCertificate[0]["No"]) {
                        jobIDArr[idx] = {
                          ...jobIDArr[idx],
                          ...isFoundCertificate[0],
                          isCertificateComplete: true,
                          jobID: jobIDArr[idx]["jobID"],
                        };
                        // console.log(jobIDArr[idx])
                        // console.log(isFoundCertificate)
                      } else {
                        jobIDArr[idx] = {
                          ...jobIDArr[idx],
                          ...isFoundCertificate[0],
                          isCertificateComplete: false,
                        };
                        // console.log(jobIDArr[idx])
                      }
                    }
                  }
                });
              });
              let previousYPosition =
                this.props.location?.state?.yPosition || this.state.yPosition;

              jobIDArr.sort((a, b) => {
                if (
                  parseInt(a["jobID"]) == parseInt(b["jobID"]) &&
                  `${a["jobID"]}`.indexOf("-") != -1 &&
                  `${b["jobID"]}`.indexOf("-") != -1
                ) {
                  if (parseInt(a["licenseID"]) == parseInt(b["licenseID"])) {
                    return parseInt(a["subID"]) - parseInt(b["subID"]);
                  } else {
                    return parseInt(a["licenseID"]) - parseInt(b["licenseID"]);
                  }
                } else {
                  return parseInt(a["jobID"]) - parseInt(b["jobID"]);
                }
              });
              let jobIDSortedAlphaArr = [];
              let jobIDSortedNumberArr = [];

              jobIDArr.sort((a, b) => {
                if (
                  `${a["jobID"]}`.indexOf("-") != -1 &&
                  `${b["jobID"]}`.indexOf("-") != -1
                ) {
                  return (
                    `${a["jobID"]}`.split("-")[1].charCodeAt(0) -
                    65 -
                    (`${b["jobID"]}`.split("-")[1].charCodeAt(0) - 65)
                  );
                }
              });

              jobIDArr.map((obj) => {
                if (`${obj["jobID"]}`.indexOf("-") != -1) {
                  jobIDSortedAlphaArr.push(obj);
                } else {
                  jobIDSortedNumberArr.push(obj);
                }
              });

              jobIDSortedAlphaArr.sort((a, b) => {
                if (
                  `${a["jobID"]}`.indexOf("-") != -1 &&
                  `${b["jobID"]}`.indexOf("-") != -1
                ) {
                  return (
                    `${a["jobID"]}`.split("-")[1].charCodeAt(0) -
                    65 -
                    (`${b["jobID"]}`.split("-")[1].charCodeAt(0) - 65)
                  );
                }
              }); //ข้อควรระวัง ไม่สามารถใช้ได้ในกรณี [10,10-A,11,11-A,11-B,11-C]
              jobIDArr = [...jobIDSortedNumberArr, ...jobIDSortedAlphaArr];

              let dateString = null;

              if (viewDateCertificate) {
                viewDateCertificate = new Date(
                  Object.values(viewDateCertificate)[0]["timeShow"]
                );
                dateString = `${parseInt(viewDateCertificate.getDate())}   ${months[parseInt(viewDateCertificate.getMonth())]
                  }  ${viewDateCertificate.getFullYear()}`;
              }
              let dateData = new Date(saveDate);
              let dataDay = parseInt(dateData.getDate());
              let dataMonth = months[dateData.getMonth()];
              let dataYear = dateData.getFullYear();

              this.setState(
                {
                  ...this.state,
                  viewAllSurveyRequestSheetByDate: jobIDArr,
                  inCompleteLoading: false,
                  allCompany: viewAllCompany,
                  timeShow: viewDateCertificate || new Date(saveDate),
                  timeValue:
                    dateString || `${dataDay}   ${dataMonth}  ${dataYear}`,
                  viewFullNameRiceAsSample: viewFullNameRiceAsSample
                },
                () => {
                  window.scrollTo(0, previousYPosition);
                }
              );
            });
        });
      })
      .catch((e) => {
        // window.location.reload()
      });
  }
  handleTableClick = (e, idx, jobID) => {
    this.state.yPosition = window.pageYOffset;
    let date = new Date();
    let days = date.getDate();
    if (parseInt(days) < 10) {
      days = `0${days}`;
    }
    let month = parseInt(date.getMonth()) + 1;
    if (parseInt(month) < 10) {
      month = `0${month}`;
    }
    let year = date.getFullYear();
    let saveDate = `${year}-${month}-${days}`;

    if (e.target.parentElement.id) {
      let pageIndex = 0;
      console.log(this.state.viewAllSurveyRequestSheetByDate[idx])
      let targetDescription = null
      if(isArray(this.state.viewAllSurveyRequestSheetByDate[idx].description)){
        targetDescription = this.state.viewAllSurveyRequestSheetByDate[idx].description
      }else{
        targetDescription = Object.values(this.state.viewAllSurveyRequestSheetByDate[idx].description)
      }
      targetDescription.map(
        (o, idz) => {
          if (
            this.state.viewAllSurveyRequestSheetByDate[idx]["licenseID"] ==
            "9999999999999"
          ) {
            let vehicleKey = "";
            Object.keys(o).map((key) => {
              if (key.indexOf("vehicleName") != -1) vehicleKey = key;
            });
            if (
              o[vehicleKey] ==
              this.state.viewAllSurveyRequestSheetByDate[idx][vehicleKey]
            ) {
              pageIndex = idz;
            }
          } else if (
            o.licenseID ==
            this.state.viewAllSurveyRequestSheetByDate[idx]["licenseID"] &&
            o.subID == this.state.viewAllSurveyRequestSheetByDate[idx]["subID"]
          ) {
            pageIndex = idz;
          }
        }
      );

      // console.log(pageIndex)

      this.props.history.push({
        pathname: "/CertiPage",
        state: {
          ...this.state.viewAllSurveyRequestSheetByDate[idx],
          timeValue: this.props.location?.state?.timeValue || saveDate,
          timeShow: this.props.location.state.timeShow,
        },
        companyNameEN:
          this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id][
          "companyEN"
          ],
        rawData: this.state.rawData,
        pageIndex: pageIndex,
        itemIndex: jobID,
        timeValue: this.props.location?.state?.timeValue || saveDate,
        timeShow: this.props.location.state.timeShow,
        allCompany: this.state.allCompany,
        currentDate: this.state.timeValue,
        minusHeight: this.state.minusHeight,
        yPosition: this.state.yPosition,
        minusCurrentDate: this.state.minusCurrentDate,
        minusCertNo: this.state.minusCertNo,
      });
    }
  };
  goSearchCertNo = (e) => {
    let certNo = e.target.value;
    this.setState({
      ...this.state,
      searchCertNo: certNo,
    });
  };
  renderQuantity(data) {
    if (data['License'] == '0308116546422') {
      console.log(data)
    }
    if (data["bagQuantity"]) {
      if (`${data["bagQuantity"]}`.indexOf("kgs.nett") != -1) {

        let totalNett = (parseFloat(`${data["netWeight"]}`) / 1000).toFixed(4);
        totalNett = (parseFloat(`${data['checkWeight']["netWeight"]}`) * parseFloat(`${data['checkWeight']["Quantity"]}`) / 1000).toFixed(4);
        return totalNett
      } else {
        return (
          (parseFloat(data["netWeight"]) *
            parseFloat(`${data["bagQuantity"]}`?.replaceAll(",", ""))) /
          1000
        ).toFixed(4);
      }
    } else if (data["Quantity"]) {
      return (
        (parseFloat(data["netWeight"]) *
          parseFloat(`${data["Quantity"]}`?.replaceAll(",", ""))) /
        1000
      ).toFixed(4);
    }
  }
  searchJob(e) {
    let jobID = parseInt(e.target.value);
    let SurveyData = this.state.rawData;
    if (jobID > 0) {
      let arr = Object.values(SurveyData).filter((d) => {
        return d["jobID"].indexOf(jobID) != -1;
      });
      this.setState({
        ...this.state,
        viewAllSurveyRequestSheetByDate: arr,
      });
    } else {
      this.setState({
        ...this.state,
        viewAllSurveyRequestSheetByDate: SurveyData,
      });
      // console.log(SurveyData)
    }
  }
  getNoOld(cerArr, licenseID, jobID, subID) {
    let obj = Object.values(cerArr).filter((o) => {
      return o.License == licenseID && o.jobID == jobID && o.subID == subID;
    })[0];
    // console.log(obj)
    if (obj) {
      return `${obj["NoOld"]}`;
    } else {
      return null;
    }
  }
  handleInputCertNo(e, jobID, licenseID, subID) {
    let newCertNoArr = this.state.viewAllSurveyRequestSheetByDate;
    let strID = e.target.id.split("-");
    strID = strID[1];
    newCertNoArr[strID] = {
      ...newCertNoArr[strID],
      No: `${e.target.value}`,
      NoOld: newCertNoArr[strID]["NoOld"] || `${this.getRandomInt(1000000)}`,
    };
    this.setState({
      ...this.state,
      viewAllSurveyRequestSheetByDate: newCertNoArr,
    });
  }
  handleInputStartPageNo(e, jobID, licenseID, subID) {
    let newCertNoArr = this.state.viewAllSurveyRequestSheetByDate;
    let strID = e.target.id.split("-");
    strID = strID[1];
    console.log(newCertNoArr[strID]);
    newCertNoArr[strID] = {
      ...newCertNoArr[strID],
      pageNoStart: `${e.target.value}`,
      NoOld: newCertNoArr[strID]["NoOld"] || `${this.getRandomInt(1000000)}`,
    };
    this.setState({
      ...this.state,
      viewAllSurveyRequestSheetByDate: newCertNoArr,
    });
  }
  handleInputStopPageNo(e, jobID, licenseID, subID) {
    let newCertNoArr = this.state.viewAllSurveyRequestSheetByDate;
    let strID = e.target.id.split("-");
    strID = strID[1];
    newCertNoArr[strID] = {
      ...newCertNoArr[strID],
      pageNoStop: `${e.target.value}`,
      NoOld: newCertNoArr[strID]["NoOld"] || `${this.getRandomInt(1000000)}`,
    };
    this.setState({
      ...this.state,
      viewAllSurveyRequestSheetByDate: newCertNoArr,
    });
  }
  getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }

  handleClickCreateCertNO() {
    let newData = this.state.viewAllSurveyRequestSheetByDate;

    // outputData.map((o) => {
    //   if (!o['NoOld'] || o['NoOld'] == 'null') {
    //     o['NoOld'] = `${this.getRandomInt(1000000)}`
    //   }
    // })
    console.log(newData)
    function checkIsContainOnlyNumber(str) {
      console.log(str)
      let result = /^\d+$/.test(str)
      return result;
    }
    newData = newData.filter((o) => {
      let isNumber = checkIsContainOnlyNumber(o['licenseID'])
      // console.log(isNumber, o['No'], (o["No"] && isNumber))
      return (o["No"] && isNumber)
    })
    // console.log(newData)
    let anotherData = []
    let pairData = []
    newData.map((o) => {

      if (o['checkWeight']) {
        let newObject = {
          ...o,
          riceTypeID: o['checkWeight']['riceTypeID'] || '',
        }
        anotherData.push(newObject)
      }
    })
    // console.log(newData)
    // console.log(anotherData)
    // pairData.map((o,idx)=>{
    //   if(o['new'] != o['origin']){
    //     console.log(newData[idx])
    //   }
    // })

    axios
      .post("https://backend1.riceinspections.com/testDD", {
        data: {
          arr: { ...anotherData },
        },
      })
      .then((res) => {
        alert("บันทึกสำเร็จ");
      })
  }
  renderDisplay(output, licenseID, data) {
    if (output["isCheckWeightComplete"] != true) {
      // console.log(output)
      if (this.state.arrCancelData[data["jobID"]]) {
        return "None";
      }
      if (licenseID == "9999999") {
        return "";
      }
      return "None";
    } else {
      return "";
    }
  }
  onChageDate = (date) => {
    date = new Date(date);
    let days = date.getDate();
    if (parseInt(days) < 10) {
      days = `0${days}`;
    }
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let month = months[date.getMonth()];
    if (parseInt(month) < 10) {
      month = `0${month}`;
    }
    let year = date.getFullYear();
    let saveDate = `${parseInt(days)}   ${month}  ${year}`;

    this.setState({
      ...this.state,
      timeValue: saveDate,
      timeShow: date,
    });
  };
  changeMinusHeight(e) {
    this.setState({
      ...this.state,
      minusHeight: parseFloat(e.target.value) || 0,
    });
  }
  minusCurrentDate(e) {
    this.setState({
      ...this.state,
      minusCurrentDate: parseFloat(e.target.value) || 0,
    });
  }
  minusCertNo(e) {
    this.setState({
      ...this.state,
      minusCertNo: parseFloat(e.target.value) || 0,
    });
  }

  handleClickCreateDateCertificate(saveDate, date) {
    axios
      .post("https://backend1.riceinspections.com/testGB", {
        data: {
          timeValue: saveDate,
          timeShow: date,
          certDate: this.props.location?.state?.timeValue,
        },
      })
      .then((res) => {
        alert("บันทึกสำเร็จ");
      });
  }
  removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  }

  handlePressEnterCertNo(e, resolve) {
    if (e.key == "Enter") {
      let startCertNo = `${e.target.value}` || "0";
      let newData = this.state.viewAllSurveyRequestSheetByDate;
      let strid = e.target.id.split("-")[1];
      newData.map((data, idx) => {
        if (idx > parseInt(strid)) {
          startCertNo = this.incrementString(startCertNo);
          newData[idx] = {
            ...newData[idx],
            No: startCertNo,
            NoOld: newData[idx]["NoOld"] || `${this.getRandomInt(1000000)}`,
          };
        }
      });
      // console.log(a)
      this.setState({
        ...this.state,
        viewAllSurveyRequestSheetByDate: newData,
      });
    }
  }
  handlePressEnterStartCertNo(e, resolve) {
    if (e.key == "Enter") {
      let startCertNo = `${e.target.value}` || "0";
      let newData = this.state.viewAllSurveyRequestSheetByDate;
      let strid = e.target.id.split("-")[1];
      newData.map((data, idx) => {
        if (idx > parseInt(strid)) {
          startCertNo = this.incrementString(startCertNo, 2);
          newData[idx] = {
            ...newData[idx],
            pageNoStart: startCertNo,
            NoOld: newData[idx]["NoOld"] || `${this.getRandomInt(1000000)}`,
          };
        }
      });
      // console.log(a)
      this.setState({
        ...this.state,
        viewAllSurveyRequestSheetByDate: newData,
      });
    }
  }
  handlePressEnterStopCertNo(e, resolve) {
    if (e.key == "Enter") {
      let startCertNo = `${e.target.value}` || "0";
      let newData = this.state.viewAllSurveyRequestSheetByDate;
      let strid = e.target.id.split("-")[1];
      newData.map((data, idx) => {
        if (idx > parseInt(strid)) {
          startCertNo = this.incrementString(startCertNo, 2);
          newData[idx] = {
            ...newData[idx],
            pageNoStop: startCertNo,
            NoOld: newData[idx]["NoOld"] || `${this.getRandomInt(1000000)}`,
          };
        }
      });
      // console.log(a)
      this.setState({
        ...this.state,
        viewAllSurveyRequestSheetByDate: newData,
      });
    }
  }
  incrementString(str, numAdd = 1) {
    var text = str;
    var getPart = text.replace(/[^\d.]/g, ""); // returns 0023
    var num = parseInt(getPart); // returns 23
    var newVal = num + numAdd; // returns 24
    var reg = new RegExp(num); // create dynamic regexp
    var newstring = text.replace(reg, newVal); // returns MPG_0024
    return newstring;
  }
  handlePressEnterGoSearchCertNo(e) {
    if (e.key == "Enter") {
      let certNo = this.state.searchCertNo;
      let dataArr = this.state.viewAllSurveyRequestSheetByDate;
      let isFoundData = dataArr.filter((o) => `${o["No"]}` == `${certNo}`);
      if (isFoundData.length > 0) {
        isFoundData = isFoundData[0];
        let pageIndex = 0;
        isFoundData.description.map((o, idz) => {
          if (
            o.licenseID == isFoundData["licenseID"] &&
            o.subID == isFoundData["subID"]
          ) {
            pageIndex = idz;
          }
        });
        this.state.yPosition = window.pageYOffset;
        let date = new Date();
        let days = date.getDate();
        if (parseInt(days) < 10) {
          days = `0${days}`;
        }
        let month = parseInt(date.getMonth()) + 1;
        if (parseInt(month) < 10) {
          month = `0${month}`;
        }
        let year = date.getFullYear();
        let saveDate = `${year}-${month}-${days}`;

        this.props.history.push({
          pathname: "/CertiPage",
          state: {
            ...isFoundData,
            timeValue: this.props.location?.state?.timeValue || saveDate,
            timeShow: this.props.location.state.timeShow,
          },
          companyNameEN: isFoundData["companyEN"],
          rawData: this.state.rawData,
          pageIndex: pageIndex,
          itemIndex: isFoundData["jobID"],
          timeValue: this.props.location?.state?.timeValue || saveDate,
          timeShow: this.props.location.state.timeShow,
          allCompany: this.state.allCompany,
          currentDate: this.state.timeValue,
          minusHeight: this.state.minusHeight,
          yPosition: this.state.yPosition,
          minusCurrentDate: this.state.minusCurrentDate,
          minusCertNo: this.state.minusCertNo,
        });
      }
    }
  }
  render() {
    if (!this.state.inCompleteLoading) {
      return (
        <Container>
          <AdminNav></AdminNav>

          <Navbar
            style={{ backgroundColor: "#F5F5F5", zIndex: "0" }}
            sticky="top"
          >
            <Container style={{ zIndex: "0" }}>
              <div style={{ width: "25%" }}>
                <p>
                  <b>
                    Quality and Weight Certificate ประจำวันที่{" "}
                    {this.props.location?.state?.timeValue}
                  </b>
                </p>
                <Button onClick={this.handleClickCreateCertNO}> บันทึก </Button>
                &nbsp;&nbsp;&nbsp;
                <Button
                  onClick={() => {
                    this.handleClickCreateDateCertificate(
                      this.state.timeValue,
                      this.state.timeShow
                    );
                  }}
                >
                  {" "}
                  บันทึกวันที่{" "}
                </Button>
              </div>
              <div>
                <label>ลดระยะหัวกระดาษ</label>{" "}
                <input
                  defaultValue={this.state.minusHeight}
                  onChange={(e) => {
                    this.changeMinusHeight(e);
                  }}
                ></input>
              </div>
              <div>
                <label>ลดระยะวันที่</label>{" "}
                <input
                  defaultValue={this.state.minusCurrentDate}
                  onChange={(e) => {
                    this.minusCurrentDate(e);
                  }}
                ></input>
              </div>
              <div>
                <label>ลดระยะเลขที่หนังสือ</label>{" "}
                <input
                  defaultValue={this.state.minusCertNo}
                  onChange={(e) => {
                    this.minusCertNo(e);
                  }}
                ></input>
              </div>
              <div>
                <label>ค้นหาเลขที่หนังสือ</label>{" "}
                <input
                  defaultValue={this.state.minusCertNo}
                  onChange={(e) => {
                    this.goSearchCertNo(e);
                  }}
                  onKeyDown={(e) => {
                    this.handlePressEnterGoSearchCertNo(e);
                  }}
                ></input>
              </div>
            </Container >
            {/* <Container style={{ zIndex: '0' }} >
              <p><b>Quality and Weight Certificate ประจำวันที่ {this.props.location?.state?.timeValue}</b></p>
            </Container> */}
          </Navbar>

          <div
            style={{
              width: "100%",
              alignContent: "center",
              textAlign: "center",
              fontSize: "22px",
            }}
          ></div>

          <DatePicker
            className="form-control"
            selected={this.state.timeShow || new Date()}
            onChange={this.onChageDate}
            timeFormat="HH:mm"
            timeIntervals={15}
            timeCaption="time"
            dateFormat="MMMM d, yyyy"
          />

          <Table bordered hover style={{ tableLayout: "fixed" }}>
            <thead>
              <tr>
                <th
                  style={{ width: "3.7%", overflow: "auto", fontSize: "11px" }}
                >
                  Cert No.
                </th>
                <th
                  style={{ width: "3.7%", overflow: "auto", fontSize: "11px" }}
                >
                  Paper No. (Origin)
                </th>
                <th
                  style={{ width: "3.7%", overflow: "auto", fontSize: "11px" }}
                >
                  Paper No. (Copy)
                </th>
                <th
                  style={{ width: "3.7%", overflow: "auto", fontSize: "11px" }}
                >
                  เลขทะเบียนงาน
                </th>
                <th
                  style={{ width: "3.7%", overflow: "auto", fontSize: "11px" }}
                >
                  เลขที่ใบอนุญาต
                </th>
                <th
                  style={{ width: "3.7%", overflow: "auto", fontSize: "11px" }}
                >
                  รายการที่
                </th>
                <th
                  style={{ width: "3.7%", overflow: "auto", fontSize: "11px" }}
                >
                  ชื่อบริษัท
                </th>
                <th
                  style={{ width: "3.7%", overflow: "auto", fontSize: "11px" }}
                >
                  สถานที่ส่งออก
                </th>
                <th
                  style={{ width: "3.7%", overflow: "auto", fontSize: "11px" }}
                >
                  ชื่อพาหนะ
                </th>
                <th
                  style={{ width: "3.7%", overflow: "auto", fontSize: "11px" }}
                >
                  ประเทศปลายทาง
                </th>
                {/* <th
                  style={{ width: "3.7%", overflow: "auto", fontSize: "11px" }}
                >
                  ชนิดข้าว (EN)
                </th> */}

                <th
                  style={{ width: "3.7%", overflow: "auto", fontSize: "11px" }}
                >
                  ชนิดข้าว
                </th>
                <th
                  style={{ width: "3.7%", overflow: "auto", fontSize: "11px" }}
                >
                  ปริมาณ / ตัน
                </th>
              </tr>
            </thead>
            <tbody style={{ width: "100%" }}>
              {/* {console.log(this.state.viewAllSurveyRequestSheetByDate)} */}
              {(() => {
                if (this.state.viewAllSurveyRequestSheetByDate) {
                  let indexForAll = 0;
                  // console.log(this.state.viewAllSurveyRequestSheetByDate)
                  return Object.keys(
                    this.state.viewAllSurveyRequestSheetByDate
                  ).map((dataName, idz) => {
                    let data =
                      this.state.viewAllSurveyRequestSheetByDate[dataName];
                    let certNo = this.state.certNoArr;
                    // console.log(data)
                    if (data === "requestCount") {
                      return null;
                    } else {
                      let vehicleKey = "";
                      if (data["checkWeight"]) {
                        Object.keys(data["checkWeight"]).map((key) => {
                          if (key.indexOf("vehicleName") != -1)
                            vehicleKey = key;
                        });
                      } else {
                        Object.keys(data).map((key) => {
                          if (key.indexOf("vehicleName") != -1)
                            vehicleKey = key;
                        });
                      }
                      // console.log(No)
                      if (
                        this.renderDisplay(
                          data,
                          data["licenseID"]?.slice(6, 13),
                          data
                        ) != "None"
                      ) {
                        indexForAll += 1;
                      }
                      let cert = "";
                      // console.log(idz,Object.keys(this.state.viewAllSurveyRequestSheetByDate).length-1)
                      // console.log(data,data['jobID'],data['licenseID'])

                      // let isFoundDescription = data.description.filter(o => o['licenseID'] === data['licenseID'] && o['subID'] === data['subID'])
                      // console.log(isFoundDescription)


                      let getRiceEN = (traffic, newTraffic, idx) => {
                        if (newTraffic && traffic) {
                          traffic = traffic.trim()
                          // console.log(traffic)
                          //WhiteBrokenRiceA1Super
                          let a = { "0": { "trafficType": "1006.30.30-003", "des": "", "riceEN": "WhiteGlutinousRice10" }, "1": { "trafficType": "1006.20.90-607", "des": "", "riceEN": "BlackCargoRiceSuperbQuality" }, "2": { "trafficType": "1006.30.40-001", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "3": { "trafficType": "1006.20.90-613", "des": "", "riceEN": "RedCargoRiceSuperbQuality" }, "4": { "trafficType": "1006.30.99-001", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "5": { "trafficType": "1006.20.90-619", "des": "", "riceEN": "BlackGlutinousCargoRiceStandardQuality" }, "6": { "trafficType": "1006.20.90-608", "des": "", "riceEN": "BlackCargoRicePrimeQuality" }, "7": { "trafficType": "1006.20.90-614", "des": "", "riceEN": "RedCargoRicePrimeQuality" }, "8": { "trafficType": "1006.20.90-501", "des": "" }, "9": { "trafficType": "1006.20.90-001", "des": "", "riceEN": "ThaiFragrantCargoRice100" }, "10": { "trafficType": "1006.20.90-606", "des": "", "riceEN": "BlackCargoRicePrimeQuality" }, "11": { "trafficType": "1006.20.90-612", "des": "", "riceEN": "RedCargoRicePrimeQuality" }, "12": { "trafficType": "1006.30.91-002", "des": "" }, "13": { "trafficType": "1006.30.99-018", "des": "", "riceEN": "WhiteRice25" }, "14": { "trafficType": "1006.30.99-012", "des": "", "riceEN": "WhiteRice5" }, "15": { "trafficType": "1006.30.30-006", "des": "" }, "16": { "trafficType": "1006.30.99-007", "des": "" }, "17": { "trafficType": "1006.40.90-006", "des": "WhiteBrokenRiceA1Super", "riceEN": "WhiteBrokenRiceA1Super" }, "18": { "trafficType": "1006.40.90-019", "des": "", "riceEN": "WhiteGlutinousBrokenRiceA1" }, "19": { "trafficType": "1006.40.90-602", "des": "", "riceEN": "WhiteGlutinousBrokenRiceAsPerSample" }, "20": { "trafficType": "1006.30.91-001", "des": "", "riceEN": "ParboiledRice100Sorted" }, "21": { "trafficType": "1006.30.91-600", "des": "", "riceEN": "ParboiledRiceAsPerSample" }, "22": { "trafficType": "1006.30.99-013", "des": "", "riceEN": "WhiteRice10" }, "23": { "trafficType": "1006.30.91-003", "des": "", "riceEN": "ParboiledRice5Sorted" }, "24": { "trafficType": "1006.40.90-005", "des": "", "riceEN": "ThaiFragrantWhiteBrokenRiceA1Super" }, "25": { "trafficType": "1006.20.90-018", "des": "", "riceEN": "CargoRice100GradeB" }, "26": { "trafficType": "1006.20.90-616", "des": "" }, "27": { "trafficType": "1006.30.99-010", "des": "", "riceEN": "WhiteRice100B" }, "28": { "trafficType": "1006.30.99-601", "des": "", "riceEN": "WhiteRiceAsPerSample" }, "29": { "trafficType": "1006.40.90-012", "des": "", "riceEN": "ThaiFragrantWhiteBrokenRiceA1Super" }, "30": { "trafficType": "1006.20.90-604", "des": "", "riceEN": "SpecialMixedCargoRiceAsPerSample" }, "31": { "trafficType": "1006.20.90-504", "des": "", "riceEN": "CargoRiceAsPerSample" }, "32": { "trafficType": "1006.20.90-615", "des": "", "riceEN": "RedCargoRiceSuperbQuality" }, "33": { "trafficType": "1006.40.90-010", "des": "", "riceEN": "ThaiFragrantWhiteBrokenRiceA1ExtraSuper" }, "34": { "trafficType": "1006.30.99-003", "des": "", "riceEN": "ThaiFragrantWhiteRice5" }, "35": { "trafficType": "1006.30.99-600", "des": "", "riceEN": "ThaiFragrantWhiteRiceAsPerSample" }, "36": { "trafficType": "1006.20.90-506", "des": "", "riceEN": "ThaiFragrantCargoRice100" }, "37": { "trafficType": "1006.20.90-633", "des": "", "riceEN": "BlackCargoRiceAsPerSample" }, "38": { "trafficType": "1006.30.99-014", "des": "", "riceEN": "WhiteRice15" }, "39": { "trafficType": "1006.20.90-600", "des": "", 'riceEN': 'CargoParboiledRiceAsPerSample' }, "40": { "trafficType": "1006.20.90-601", "des": "", "riceEN": "ThaiFragrantCargoRiceAsPerSample" }, "41": { "trafficType": "1006.30.99-603", "des": "", "riceEN": "SpecialMixedRiceAsPerSample" }, "42": { "trafficType": "1006.20.90-630", "des": "" }, "43": { "trafficType": "1006.20.90-618", "des": "", "riceEN": "BlackGlutinousCargoRiceBestQuality" }, "44": { "trafficType": "1006.40.90-018", "des": "", "riceEN": "ParboiledBrokenRiceA1" }, "45": { "trafficType": "1006.40.90-600", "des": "", "riceEN": "WhiteBrokenRiceC1AsPerSample" }, "46": { "trafficType": "1006.30.30-004", "des": "", "riceEN": "WhiteGlutinousRice10" }, "47": { "trafficType": "1006.40.90-001", "des": "", "riceEN": "CargoBrokenRiceAsPerSample" }, "48": { "trafficType": "1006.20.90-632", "des": "" }, "49": { "trafficType": "1006.30.91-007", "des": "", "riceEN": "ParboiledRice15" }, "50": { "trafficType": "1006.30.91-004", "des": "", "riceEN": "ParboiledRice5" }, "51": { "trafficType": "1006.20.90-010", "des": "", "riceEN": "CargoRice5" }, "52": { "trafficType": "1006.30.99-009", "des": "", "riceEN": "WhiteRice100A" }, "53": { "trafficType": "1006.20.90-609", "des": "", "riceEN": "BlackCargoRiceSuperbQuality" }, "54": { "trafficType": "1006.30.99-015", "des": "" }, "55": { "trafficType": "1006.30.99-502", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "56": { "trafficType": "1006.30.40-500", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "57": { "trafficType": "1006.40.90-004", "des": "", "riceEN": "WhiteBrokenRiceA1ExtraSuper" }, "58": { "trafficType": "1006.30.99-602", "des": "", "riceEN": "WhiteRiceAsPerSample" }, "59": { "trafficType": "1006.20.90-610", "des": "", "riceEN": "BlackCargoRiceAsPerSample" }, "60": { "trafficType": "1006.20.90-622", "des": "", "riceEN": 'BlackGlutinousCargoRiceAsPerSample' }, "61": { "trafficType": "1006.20.90-631", "des": "" }, "62": { "trafficType": "1006.20.90-605", "des": "", "riceEN": "RedCargoRiceSuperbQuality" }, "63": { "trafficType": "1006.30.30-601", "des": "" }, "64": { "trafficType": "1006.30.99-023", "des": "", "riceEN": "WhiteRiceEnrichedVitaminAsPerSample" }, "65": { "trafficType": "1006.30.40-006", "des": "", "riceEN": "ThaiFragrantWhiteRice15" }, "66": { "trafficType": "1006.40.90-003", "des": "" }, "67": { "trafficType": "1006.30.99-022", "des": "", "riceEN": "WhiteRice45" }, "68": { "trafficType": "1006.30.99-011", "des": "", "riceEN": "WhiteRice100C" }, "69": { "trafficType": "1006.30.99-005", "des": "" }, "70": { "trafficType": "1006.20.90-011", "des": "", "riceEN": "CargoRice10" }, "71": { "trafficType": "1006.40.90-609", "des": "" }, "72": { "trafficType": "1006.20.90-012", "des": "" }, "73": { "trafficType": "1006.20.90-508", "des": "" }, "74": { "trafficType": "1006.20.90-611", "des": "" }, "75": { "trafficType": "1006.20.90-617", "des": "" }, "76": { "trafficType": "1006.20.90-620", "des": "", "riceEN": "BlackGlutinousCargoRiceBestQuality" } }
                          let arr = Object.values(newTraffic).filter((dataFilter) => {
                            return dataFilter['riceID'] == traffic
                          })
                          if (arr.length == 0) {
                            let output = traffic
                            // console.log(output)
                            Object.values(a).map((data) => {
                              if (data['trafficType'] == traffic) {
                                output = data['riceEN']
                              }
                            })
                            if (idx == 1) {
                              return output
                            } else {
                              return ''
                            }
                          } else {
                            let data = arr[0]
                            // console.log(data)
                            if (idx == 1) {
                              // console.log(data['wtf'])
                              // console.log(this.convertDeCodeText(data['wtf']))
                              return this.convertDeCodeText(data['wtf'])
                            } else if (idx == 2) {
                              return this.convertDeCodeText(data['wtf2'])
                            } else if (idx == 3) {
                              return this.convertDeCodeText(data['wtf3'])
                            }

                          }
                        }

                      }

                      // if(isFoundDescription.length > 0){
                      //   console.log(data['licenseID'],data['subID'],isFoundDescription[0]['riceTypeID'],convertRiceTypeENToENFull(getRiceEN(isFoundDescription[0]['riceTypeID'], this.state.viewFullNameRiceAsSample, 1)))

                      // }



                      return (

                        <tr
                          id={idz}
                          onClick={(e) => {
                            this.handleTableClick(e, idz, data["jobID"]);
                          }}
                          style={{
                            backgroundColor: data["PackingType1"]
                              ? "#90ee90"
                              : "white",
                            display: this.renderDisplay(
                              data,
                              data["licenseID"]?.slice(6, 13),
                              data
                            ),
                          }}
                        >
                          <td>
                            <input
                              id={`CertNo-${idz}`}
                              style={{ width: "100%", fontSize: "13px" }}
                              onChange={(e) => {
                                this.handleInputCertNo(
                                  e,
                                  data["jobID"],
                                  data.licenseID,
                                  data.subID
                                );
                              }}
                              onKeyDown={(e) => {
                                this.handlePressEnterCertNo(e);
                              }}
                              value={data?.["No"] || ""}
                            ></input>
                          </td>
                          <td>
                            <input
                              id={`StartNo-${idz}`}
                              style={{ width: "100%", fontSize: "13px" }}
                              onChange={(e) => {
                                this.handleInputStartPageNo(
                                  e,
                                  data["jobID"],
                                  data.licenseID,
                                  data.subID
                                );
                              }}
                              onKeyDown={(e) => {
                                this.handlePressEnterStartCertNo(e);
                              }}
                              value={data?.["pageNoStart"]}
                            ></input>
                          </td>
                          <td>
                            <input
                              id={`Stop-${idz}`}
                              style={{ width: "100%", fontSize: "13px" }}
                              onChange={(e) => {
                                this.handleInputStopPageNo(
                                  e,
                                  data["jobID"],
                                  data.licenseID,
                                  data.subID
                                );
                              }}
                              onKeyDown={(e) => {
                                this.handlePressEnterStopCertNo(e);
                              }}
                              value={data?.["pageNoStop"]}
                            ></input>
                          </td>
                          <td style={{ fontSize: "13px" }}>
                            <b>{data["jobID"]}</b>
                          </td>
                          <td style={{ fontSize: "13px" }}>
                            <b>{data["licenseID"]?.slice(6, 13)}</b>
                          </td>
                          <td style={{ fontSize: "13px" }}>
                            <b>{parseInt(data["subID"]) + 1}</b>
                          </td>
                          <td style={{ overflow: "auto", fontSize: "13px" }}>
                            <b>{data["companyID"]}</b>
                          </td>
                          <td style={{ fontSize: "13px" }}>
                            <b>
                              {data["surveyLocateName"]} -{" "}
                              {data["surveyProvince"]}
                            </b>
                          </td>
                          <td style={{ fontSize: "13px" }}>
                            <b>
                              {data["checkWeight"]?.[vehicleKey] ||
                                data[vehicleKey]}
                            </b>
                          </td>
                          <td style={{ fontSize: "13px" }}>
                            <b>
                              {data["checkWeight"]?.["destinationCity"] ||
                                data["Destination"]}
                            </b>
                          </td>
                          <td style={{ fontSize: "13px" }}>
                            <b>
                              {data["checkWeight"]?.["riceTypeName"] ||
                                convertRiceTypeENToTH(
                                  data["checkWeight"]?.["riceTypeID"] ||
                                  data["riceTypeID"],
                                  this.state.riceTypeIDAndName,
                                  "standalone"
                                ) ||
                                data["riceTypeName"]}{" "}
                            </b>
                          </td>
                          <td style={{ fontSize: "13px" }}>
                            <b>{addCommaInNumber(this.renderQuantity(data))}</b>{" "}
                            <br />{" "}
                          </td>
                        </tr>
                      );
                    }
                  });
                }
              })()}
            </tbody>
          </Table>
        </Container >
      );
    } else {
      return (
        <Container>
          <AdminNav></AdminNav>
          <Loading />
        </Container >
      );
    }
  }
}

export default withRouter(CertificateTable);
